export let BooleansSettingsKeys;
(function (BooleansSettingsKeys) {
  BooleansSettingsKeys["AutoPlay"] = "autoPlay";
  BooleansSettingsKeys["BiAppSettingsWhereOpened"] = "biAppSettingsWhereOpened";
})(BooleansSettingsKeys || (BooleansSettingsKeys = {}));
export let NumbersSettingsKeys;
(function (NumbersSettingsKeys) {
  NumbersSettingsKeys["ThumbnailButtonsBehavior"] = "thumbnailButtonsBehavior";
  NumbersSettingsKeys["MobileChannelLayout"] = "mobileChannelLayout";
  NumbersSettingsKeys["ChannelLayout"] = "channelLayout";
  NumbersSettingsKeys["PlayType"] = "playType";
  NumbersSettingsKeys["VideosInRow"] = "videosInRow";
  NumbersSettingsKeys["NumberOfRows"] = "numberOfRows";
  NumbersSettingsKeys["MainItemType"] = "mainItemType";
})(NumbersSettingsKeys || (NumbersSettingsKeys = {}));
export let FontsSettingsKeys;
(function (FontsSettingsKeys) {
  FontsSettingsKeys["ChannelId"] = "channelId";
  FontsSettingsKeys["VideoId"] = "videoId";
})(FontsSettingsKeys || (FontsSettingsKeys = {}));
export * from './channel-layout-values';
export * from './channel-video-list-values';
export * from './compact-play-type';
export * from './compact-show-video-list';
export * from './compact-video-counts';
export * from './default-settings';
export * from './default-settings-editor-x';
export * from './expanded-theme';
export * from './info-position-values';
export * from './layout-style-values';
export * from './load-more-button-type-values';
export * from './main-action-style-types';
export * from './main-item-type-values';
export * from './navigation-arrows-behavior';
export * from './navigation-arrows-position';
export * from './preview-types';
export * from './show-expanded-video-list-titles';
export * from './show-info-values';
export * from './show-media-type-values';
export * from './text-alignment-values';
export * from './thumbnail-buttons-behavior';
export * from './thumbnail-spacing-presets';
export * from './title-position-values';
export * from './versions';
export * from './video-end-options';
//# sourceMappingURL=index.js.map